import { render, staticRenderFns } from "./qrcode-static.vue?vue&type=template&id=1dcbe2b2&scoped=true&"
import script from "./qrcode-static.vue?vue&type=script&lang=js&"
export * from "./qrcode-static.vue?vue&type=script&lang=js&"
import style0 from "./qrcode-static.vue?vue&type=style&index=0&id=1dcbe2b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcbe2b2",
  null
  
)

export default component.exports